import { Container, Asset } from "./container.models";
import { Company } from "../interfaces/company";

export interface Playbook {
  id: number;
  companyId: number;
  title: string;
  coverImageKey: string;
  brandImageKey: string;
  brandAssetId: number;
  coverAssetId: number;
  mobileBrandAssetId: number;
  mobileCoverAssetId: number;
  description: string;
  coverThemeId: number;
  innerThemeId: number;
  primaryColor: string;
  accentColor: string;
  isDeleted: boolean;
  categoryId?: any;
  containers: Container[];
  conversations?: any;
  invites?: any;
  coverTheme?: any;
  innerTheme?: any;
  customCss?: any;
  customScripts?: any;
  isAvailableOffline: boolean;
  conversationsAvailable: boolean;
  emailRelease: boolean;
  enableCustomFonts: boolean;
  customFonts?: any;
  isEmbededFonts: boolean;
  isTutorialPlaybook: boolean;
  recoveryDate?: any;
  isPermanentlyDeleted: boolean;
  order: number;
  allContainers?: any;
  company: Company;
  category?: any;
  clipboardItems?: any;
  conversationTemplates?: any;
  isDraftMode: boolean;
  coverAsset: Asset;
  brandAsset: Asset;
  contentNotification?: any;
  isDisplayPlaybookTitle: boolean;
  coverHeaderBar: string;
  pageHeaderBar: string;
  sectionTitle: string;
  hyperlink: string;
  activeSection: string;
  videoPlayButton: string;
  sectionCallout: string;
  h4Headings: string;
  underlineBlock: string;
  selectedTab: string;
  coversColorsCss: string;
  playbookUserCount: number;
  languageId?: number;
  createdAt: Date | string;
  createdBy: number;
  languages: PlaybookLanguage[];
  lastUpdatedAt: Date | string;
  lastUpdatedBy: number;
  coverImageStyle?: any;
  mobileCoverImageStyle?: any;
  showImage?: boolean;
  isPlaceHolderPlaybook?: boolean;
  previewImageAssetId: number;
  lastViewedDate: Date | string;
  lastViewedOrUpdatedContainer: string;
  lastViewedOrUpdatedPageId: number;
  lastViewedOrUpdatedSectionId: number;
  playbookFeaturedContentId: number;
  featuredBy: number;
  isFeaturedContentVisibletoUser: boolean;
}
export class Playbook implements Playbook {}

export interface PlaybookLanguage {
  id?: number;
  name: string;
  playbookId: number;
  isDeleted: boolean;
}

export interface PlaybookFeaturedContent {
  id: number;
  playbookId: number;
  pageId: number;
  sectionId: number;
  playbookTitle: string;
  pageTitle: string;
  sectionTitle: string;
  activeStartDate: Date | string;
  activeEndDate: Date | string;
}

export interface OfflinePbSize {
  allLanguages: any;
  allManifests: any;
  assetManifest: any;
  codeFileSize: number;
  filesize: number;
  id?: number;
  ready: boolean;
}

export class CustomCompanyIcon {
  companyIconId: number;
  assetId: number;
  companyId: number;
  name: string;
}
